module.exports = __webpack_public_path__ + "img/boat_parked.387f90d7.svg";